import request from '@/utils/request';
// 登录
export const doLogin = (data: any): any =>
  request({
    url: '/pc/auth/login',
    data: data
  })

// 获取用户信息
export const getUserInfo = (data: any): any =>
  request({
    url: '/routuan/userinfo',
    data: data
  })

// 获取oss 临时凭证
export const getOssToken = (data: any): any =>
  request({
    url: '/common/osstoken',
    data
  })

// 获取商城设置信息
export const mallInfo = (data: any): any =>
  request({
    url: '/pc/mall/mallInfo',
    data: data
  })

// 保存商城设置信息
export const mallInfoSave = (data: any): any =>
  request({
    url: '/pc/mall/mallInfoSave',
    data: data
  })

// 修改密码
export const authpcChangePassWord = (data: any): any =>
  request({
    url: '/pc/auth/pcChangePassWord',
    data: data
  })

  // 获取登录员工菜单
export const getMenuPermission = (data: any): any =>
request({
  url: '/pc/employee/getMenuPermission',
  data: data
})


  // 发送短信验证码
  export const authsendSmsCode = (data: any): any =>
  request({
    url: '/pc/auth/sendSmsCode',
    data: data
  })
  
  // 重置密码
  export const authreSetLoginPassword = (data: any): any =>
  request({
    url: '/pc/auth/reSetLoginPassword',
    data: data
  })

  
  // 获取商城系统时间
  export const mallsystemTime = (data: any): any =>
  request({
    url: '/pc/mall/systemTime',
    data: data
  })
  // 获取小程序页面--对应短连接
  export const wxappwxappgenerateurllink = (data: any): any =>
  request({
    url: '/pc/wxapp/wxappgenerateurllink',
    data: data
  })

  
// 银行列表
export const banklist = (data: any): any =>
request({
	url: '/pc/bank/list',
	data: data
})
  
// 结算账户-信息
export const settlementAccountinfo = (data: any): any =>
request({
	url: '/pc/settlementAccount/info',
	data: data
})
// 结算账户-发送验证码
export const settlementAccountsendCode = (data: any): any =>
request({
	url: '/pc/settlementAccount/sendCode',
	data: data
})
// 结算账户-修改
export const settlementAccountedit = (data: any): any =>
request({
	url: '/pc/settlementAccount/edit',
	data: data
})

// 银行列表(财务结算用的)
export const bankFinanceSettlelist = (data: any): any =>
request({
	url: '/pc/bankFinanceSettle/list',
	data: data
})
